module.exports = __webpack_public_path__ + "static/96e1313cbc6d659ef9f478462f8d819307a3446b5b75b4cec9c3c823aeda5c49-0a0b15f781367a2c51397d796afab4b2.jpeg";